/**
 * Service: Import Exports API
 */
angular.module('acme.common.service.importExportsApi', [
  'acme.common.service.auth'
])
  .provider('ImportExportsApiService', ImportExportsApiServiceProvider);

/**
 * Service: ImportExportsApiService
 * Import Jobs API *Microservice* service
 * @constructor
 * @param {String} exportsEndpoint - the endpoint used
 * @param {Object} $http - angular $http service
 * @param AuthService
 * @return {ImportExportsApiService} -
 */
function ImportExportsApiService (exportsEndpoint, $http, AuthService) {

  var executionEndpoint = '/execution/',
    executionOutputsEndpoint = '/execution/outputs/',
    outputTypesEndpoint = '/output/types',
    outputFieldsEndpoint = '/output/fields/',
    jobOutputsEndpoint = '/outputs',
    requestObject = {
      headers: {
        'x-tenant-id': AuthService.getCookie('user').tenantId
      }
    };

  return {
    list: list,
    create: create,
    get: get,
    getOutputs: outputs,
    getTypes: types,
    getFieldsByType: getFieldsByType,
    getJobOutputs: jobOutputs,
    createOrUpdateJobOutput: createOrUpdateJobOutput,
    getDownloadUrl: getDownloadUrl,
    remove: remove
  };

  /**
   * Calls the Export get all / list endpoint
   * @memberOf ImportExportsApiService
   * @public
   * @param {Number} jobId
   * @param {any} page 
   * @param {any} size 
   * @param {any} sort 
   * @return {Promise} promise that will resolve or reject with server response
   */
  function list(jobId, page, size, sort) {
    var _page = page || null,
      _size = size || null,
      _sort = sort || null;

    return $http.get(exportsEndpoint + '/' + jobId, Object.assign(angular.copy(requestObject), {
      params: {
        page: _page,
        size: _size,
        sort: _sort
      }
    }));
  }

  /**
   *
   * @param {String} jobId
   * @param {Date} [date] - Export from object
   * @returns {*}
   */
  function create(jobId, date) {

    var createEndpoint = exportsEndpoint + '/' + jobId,
      data = {
        jobId: jobId
      },
      config = Object.assign({},requestObject, {
        params: {
          from: date && date.toISOString()
        }
      });

    return $http.post(createEndpoint, data, config);
  }

  function get(id) {
    return $http.get(exportsEndpoint + executionEndpoint + id, requestObject);
  }

  function outputs(id) {
    return $http.get(exportsEndpoint + executionOutputsEndpoint + id, requestObject);
  }

  function types() {
    return $http.get(exportsEndpoint + outputTypesEndpoint, requestObject);
  }

  function getFieldsByType(type) {
    return $http.get(exportsEndpoint + outputFieldsEndpoint + type, requestObject);
  }

  function jobOutputs(id) {
    return $http.get(exportsEndpoint + jobOutputsEndpoint + '/' + id, requestObject);
  }

  function createOrUpdateJobOutput(jobOutput) {
    return $http.post(exportsEndpoint + jobOutputsEndpoint, jobOutput, requestObject);
  }

  function getDownloadUrl(id) {
    return exportsEndpoint + '/download/' + id;
  }

  function remove(id) {
    return $http.delete(exportsEndpoint + '/' + id, requestObject); // TODO Confirm endpoint
  }
}

function ImportExportsApiServiceProvider () {}

ImportExportsApiServiceProvider.prototype.setEndpoint = function (endpoint) {
  this.endpoint = endpoint;
};

ImportExportsApiServiceProvider.prototype.$get = ['$http', 'AuthService', function ($http, AuthService) {
  return new ImportExportsApiService(this.endpoint, $http, AuthService);
}];

ImportExportsApiServiceProvider.$inject = [];
